import React from 'react';

/**
 * One of the two lists on the wizard's first step — "اختر الفصل" and the open
 * unit's topics. A 12px-round box in gray/200 with a gray/100 title strip; the
 * rows under it scroll when the box is given a height.
 */
const ListPanel = ({ title, className = '', bodyClassName = '', children }) => (
    <section
        className={
            'tw-flex tw-min-w-0 tw-flex-col tw-overflow-hidden tw-rounded-[12px] tw-border-[0.8px] tw-border-solid ' +
            `tw-border-v2-neutral-200 tw-bg-white ${className}`
        }
    >
        <h3 className="tw-m-0 tw-shrink-0 tw-bg-v2-neutral-100 tw-px-[18px] tw-py-[14px] tw-text-start tw-text-[14px] tw-font-bold tw-leading-[1.6] tw-text-v2-neutral-900">
            {title}
        </h3>
        <div className={`tw-min-h-0 tw-flex-1 tw-overflow-y-auto ${bodyClassName}`}>
            {children}
        </div>
    </section>
);

export default ListPanel;
